import { connect } from 'react-redux';

import Footer from './Footer';

export function mapStateToProps() {
  return {};
}

export function mapDispatchToProps() {
  return {};
}

export default connect<object, object>(mapStateToProps, mapDispatchToProps)(Footer);
